// Supersonic-style split heading: first line solid, second line indented
export const SectionHeading = ({ top, bottom, outline = false, testId, className = "" }) => (
  <h2 data-testid={testId} className={`uppercase leading-[0.95] text-[8vw] sm:text-5xl lg:text-6xl xl:text-7xl break-words ${className}`}>
    <span className="block font-display text-white">{top}</span>
    {bottom && (
      <span className={`block pl-[8%] ${outline ? "font-thin-brand text-white" : "font-display text-primary"}`}>{bottom}</span>
    )}
  </h2>
);

export const Label = ({ children, className = "" }) => (
  <p className={`text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-primary ${className}`}>{children}</p>
);

export const BigButton = ({ as: Tag = "a", children, className = "", ...props }) => (
  <Tag
    {...props}
    className={`inline-flex items-center gap-3 border-2 border-white text-white font-display uppercase text-xl px-8 py-4 hover:bg-white hover:text-black transition-colors duration-200 ${className}`}
  >
    {children}
  </Tag>
);
